import { styled } from '@mui/material/styles'
import TableRow from '@mui/material/TableRow'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:not(.Mui-selected):nth-of-type(odd)': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.background.paper
        : theme.palette.background.default
  }
}))

export default StyledTableRow
